import React from 'react';
import styled from 'styled-components';
import global_axios from '../funciones_globales/interaccionapi';
import { getItemDatosSesion, setDatosSesion, getItemParametros, existeSesion } from '../funciones_globales/manejosesion';
import { formatearNumeroEntero } from '../funciones_globales/format';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { MOTIVO_CAMBIO_VACIO } from '../app.constants';

const Contenedor = styled.div`
    padding-top: 5%;
    width: 60%;
    @media (max-width: 767px) {
        width: 80%;
    }
`;

const ContenedorFormAuth = styled.div`    
    widht: 45%;
    padding-left: 53%;
    padding-right: 2%;
    @media (max-width: 767px) {
        widht: 90%;
        padding-left: 5%;
        padding-right: 5%;
    };
    padding-top: 5px;
    padding-bottom: 5px;
    height: 450px;
    border: 1px solid white;
    border-radius: 2px;
    background-image: url('/img/wallpaper1.jpg');
    background-size: 100% 100%;
`;

const ContenedorPanel = styled.div`
    background: rgba(212,228,239,1);
    background: -moz-linear-gradient(left, rgba(212,228,239,1) 0%, rgba(134,174,204,1) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(212,228,239,1)), color-stop(100%, rgba(134,174,204,1)));
    background: -webkit-linear-gradient(left, rgba(212,228,239,1) 0%, rgba(134,174,204,1) 100%);
    background: -o-linear-gradient(left, rgba(212,228,239,1) 0%, rgba(134,174,204,1) 100%);
    background: -ms-linear-gradient(left, rgba(212,228,239,1) 0%, rgba(134,174,204,1) 100%);
    background: linear-gradient(to right, rgba(212,228,239,1) 0%, rgba(134,174,204,1) 100%);
    width: 100%;
`;

const ContenedorPerfil = styled.div`
    display: ${props => props.visible ? 'inline-block' : 'none'};
    width: 100%;
`;

const MensajeError = styled.h5`
    color: red;
    text-align: center;
    font-weight: 600;
`;

const Titulo = styled.h2`
    font-family: 'Exo', sans-serif;
    text-align: center;
    color: white;
    font-size: 22px;
    font-weight: 600;
`;

const ContenedorTitulo = styled.div`
   background-color: #46b8da;
`;

const Boton = styled.button`
    display: block;
    margin: auto;
    font-size: 13px;
`;

export default class Login extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            perfiles: [],
            visible_perfiles: false,
            perfil_actual: undefined,
            username: '',
            clave: '',
            msg_error: '',
            isVisibleClave: false
        }
        this.ingresar = this.ingresar.bind(this);      
        this.seleccionPerfil = this.seleccionPerfil.bind(this);
        this.submit = this.submit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.obtenerParametrosMotivosCambioProforma = this.obtenerParametrosMotivosCambioProforma.bind(this);
    }

    componentWillMount(){
        if (existeSesion()){
            this.props.history.push('/');
        }
    }

    submit(e){       
        e.preventDefault();

        if (existeSesion()){
            alert('Ya existe una sesión iniciada. Por favor cierre la sesión actual antes de continuar.');
            return;
        }

        const username = this.state.username;
        const clave = this.state.clave;        

        if (username.toString().trim().length===0){
            this.setState({msg_error: 'Complete el campo usuario'})
            return;
        }else{
            if (username.toString().trim().length> 10 ){
                this.setState({msg_error: 'El campo usuario es incorrecto'})
                return;
            }
        }

        if (clave===undefined || clave===''){
            this.setState({msg_error: 'Complete el campo clave'})
            return;
        }
        
        global_axios({
            method: 'POST',
            url: '/login',
            data: {username, clave}
        })
        .then((response)=> {
            const sesion_data = response.data;           
            this.setState({msg_error: '', visible_perfiles: true, perfiles: sesion_data.perfiles, perfil_actual: sesion_data.perfiles[0].PerfilId});
            
            const sesionExpiraEnSegundos = formatearNumeroEntero(sesion_data.tokenExpiraEnSegundos);
            setDatosSesion('usuario', sesion_data.usuario);
            setDatosSesion('token', sesion_data.token);
            setDatosSesion('sesionExpiraEnSeg', sesionExpiraEnSegundos);
            setDatosSesion('fechaInicSesion', moment().format());
        })
        .catch((error)=>{
            if (error.response){
                this.setState({msg_error: error.response.data.msg, visible_perfiles: false});
            }else{
                this.setState({msg_error: 'Existen problemas de comunicación con el servidor de Web API.', visible_perfiles: false});
            }
        });
    }

    ingresar(){
        if(this.state.perfil_actual){
            let token = getItemDatosSesion('token');
            if (token){
                
                global_axios.defaults.headers.common['x-access-token'] = token;
                
                let usuario = getItemDatosSesion('usuario');
                
                global_axios({
                    method: 'GET',
                    url: '/parametros/' + usuario + '/' + this.state.perfil_actual                    
                })
                .then((response)=> {                                  
                    const param_data = response.data.datos_inic;
                    global_axios.defaults.headers.common['empresa'] = param_data.permisos.empresaActual.Db.trim().toLowerCase();
                    setDatosSesion('empresaActual', JSON.stringify(param_data.permisos.empresaActual));
                    setDatosSesion('menu', JSON.stringify(param_data.permisos.menu));
                    setDatosSesion('perfil', JSON.stringify(param_data.permisos.perfil));
                    setDatosSesion('empresasPerfil', JSON.stringify(param_data.permisos.empresasPerfil));
                    setDatosSesion('periodo', getItemParametros(param_data.parametros, 'periodo'));                    
                    setDatosSesion('moneda', getItemParametros(param_data.parametros, 'moneda'));
                    setDatosSesion('planVigente', getItemParametros(param_data.parametros, 'planVigente'));
                    setDatosSesion('fechaUltCierreCont', getItemParametros(param_data.parametros, 'fUltCierreCont'));
                    setDatosSesion('fechasProceso', getItemParametros(param_data.parametros, 'fechasProceso'));
                    setDatosSesion('nivel', JSON.stringify(param_data.permisos.nivel));//Willy20191112 cambio de mostrar por niveles la columna de costo promedio

                    this.obtenerParametrosMotivosCambioProforma();

                    this.props.history.push("/");
                })
                .catch((error)=>{
                    if (error.response){
                        this.setState({msg_error: error.response.data.msg});
                    }else{
                        this.setState({msg_error: 'Existen problemas de comunicación con el servidor de Web API.'});
                    }
                })   
            }else{
                this.setState({msg_error: 'No existe un token válido'});
            }
        }else{
           this.setState({msg_error: 'Ud. no ha seleccionado un perfil'});
        }
    }

    obtenerParametrosMotivosCambioProforma() {
        let url = '/parametros/MOTCAMBIOPROF';
        let perfil = getItemDatosSesion('perfil');
        if(JSON.parse(perfil).hasOwnProperty('Id')) {
            url += '-' + JSON.parse(perfil).Id;
        }

        global_axios({
            url,
            method: 'GET'
        })
        .then( response => {
            let motivosCambioProforma = response.data.map(motivo => motivo.Descripcion);
            setDatosSesion('motivosCambioProf', JSON.stringify([MOTIVO_CAMBIO_VACIO].concat(motivosCambioProforma)));
        })
    }


    seleccionPerfil(event){
        this.setState({perfil_actual: event.target.value});
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    render(){
        return(     
            <Contenedor className='container'>                
                <ContenedorFormAuth>
                    <ContenedorTitulo>
                        <Titulo>Iniciar sesión</Titulo>
                    </ContenedorTitulo>
                    <ContenedorPanel className='panel panel-default'>
                        <div className='panel-body'>
                            <form id='form_login' onSubmit={this.submit}>
                                <div className='form-group'>
                                    <div className='input-group'>
                                        <span className='input-group-addon'><i className='fa fa-user'></i></span>
                                        <input 
                                            name="username"
                                            type="text"
                                            placeholder="Usuario"
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <div className='input-group'>
                                        <span className='input-group-addon'><i className='fa fa-key'></i></span>
                                        <input
                                            name="clave"                                        
                                            type={this.state.isVisibleClave?'text':'password'}
                                            placeholder="Contraseña"
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={this.handleInputChange}                           
                                        />
                                    </div>
                                </div>                                                                
                                <div className="checkbox">
                                <label><input name='isVisibleClave' type="checkbox" checked={this.state.isVisibleClave}
                                    onChange={this.handleInputChange}/>
                                    Ver Contraseña</label>
                                </div>
                                <Boton className='btn btn-default pull-center' disabled={this.state.visible_perfiles} type='submit'>Autenticar <i className="fa fa-sign-in"></i></Boton>                                
                            </form>
                            <MensajeError>{this.state.msg_error}</MensajeError>
                            <ContenedorPerfil visible={this.state.visible_perfiles}>
                                <label>Perfil:</label>
                                <div className='form-group'>
                                    <div className='input-group'>
                                        <span className='input-group-addon'><i className='fa fa-user-circle'></i></span>
                                        <select className="form-control" value={this.state.perfil_actual} onChange={this.seleccionPerfil}>
                                            {
                                                this.state.perfiles.map((perfil)=>{
                                                    return <option key={perfil.PerfilId} value={perfil.PerfilId}>{perfil.infoperfil.NombrePerfil}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <Boton className='btn btn-info pull-center' type='button' onClick={this.ingresar}>Ingresar <i className="fa fa-chevron-circle-right"></i></Boton>                            
                            </ContenedorPerfil>
                            <Link to='/cambioclave'>Cambiar contraseña</Link>
                        </div>
                    </ContenedorPanel>
                </ContenedorFormAuth>                    
            </Contenedor>            
        );
    }
}